function Toggle({ 
  leftLabel = 'Old', 
  rightLabel = 'New', 
  isRight = true, 
  onChange, 
  leftLabelActive = 'Old',
  rightLabelActive = 'New',
  ariaLabel = 'Toggle view'
}) {
  return (
    <div className="flex items-center justify-center gap-4 mb-4">
      <span className={`text-sm font-medium ${!isRight ? 'text-[#0D0D0D]' : 'text-[#666666]'}`}>
        {leftLabel}
      </span>
      <button
        onClick={() => onChange(!isRight)}
        className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-[#213553] focus:ring-offset-2 ${
          isRight ? 'bg-[#213553]' : 'bg-[#E5E5E5]'
        }`}
        aria-label={ariaLabel}
      >
        <span
          className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
            isRight ? 'translate-x-6' : 'translate-x-1'
          }`}
        />
      </button>
      <span className={`text-sm font-medium ${isRight ? 'text-[#0D0D0D]' : 'text-[#666666]'}`}>
        {rightLabel}
      </span>
    </div>
  );
}

export default Toggle;

